
  import { computed, defineComponent, onMounted, ref } from 'vue';
  import { ErrorMessage, Field, Form } from 'vee-validate';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { useRoute, useRouter } from 'vue-router';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useAbility } from '@casl/vue';
  import Swal from 'sweetalert2/dist/sweetalert2.js';
  import * as Yup from 'yup';

  export default defineComponent({
    name: 'package-editing',
    components: {
      ErrorMessage,
      Field,
      Form,
    },
    async setup() {
      const { t, te } = useI18n();
      const { can } = useAbility();
      const store = useStore();
      const router = useRouter();
      const route = useRoute();
      const submitButton = ref<HTMLButtonElement | null>(null);
      const packageData = ref<any>(null);
      const priceColor = ref<string>('');
      const color = ref<string>('');
      const viewColor = ref<string>(''); // Default color for viewColor

      enum PackagesTypes {
        MIX = 1,
        SUBSCRIPTIONS = 2,
        CREDIT = 3,
      }

      const packageTypeOptions = computed(() => {
        return Object.entries(PackagesTypes)
          .filter(([key]) => isNaN(Number(key)))
          .map(([key, value]) => [key, Number(value)]);
      });
      const offeredPrice = computed(() => {
        if (packageData.value?.price && packageData.value?.discountPercentage) {
          return (
            packageData.value.price *
            (1 - packageData.value.discountPercentage / 100)
          );
        }
        return packageData.value?.offeredPrice || 0;
      });

      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      const goBack = () => {
        router.back();
      };

      onMounted(() => {
        setCurrentPageBreadcrumbs(translate('packageUpdating'), [
          translate('subscriptions'),
        ]);
      });

      const { data } = await store.dispatch(
        Actions.GET_PACKAGE,
        route.params.id
      );
      debugger;
      packageData.value = data.data;
      priceColor.value = packageData.value.priceColor || '#000000';
      color.value = packageData.value.color || '#000000';
      viewColor.value = packageData.value.viewColor || '#000000';

      const packageSchema = Yup.object().shape({
        titleAr: Yup.string().required(translate('AR_TITLE_IS_REQUIRED')),
        titleEn: Yup.string().required(translate('EN_TITLE_IS_REQUIRED')),
        price: Yup.number().required(translate('PRICE_REQUIRED')),
        discountPercentage: Yup.number().required(
          translate('DISCOUNT_PERCENTAGE_REQUIRED')
        ),
        offeredPrice: Yup.number().required(
          translate('OFFERED_PRICE_REQUIRED')
        ),
      });

      const onSubmitUpdate = async (values) => {
        if (submitButton.value) {
          submitButton.value.disabled = true;
          submitButton.value.setAttribute('data-kt-indicator', 'on');
        }
        debugger;

        // values.offeredPrice = offeredPrice.value;
        if (values.price) values.price = Number(values.price);
        if (values.discountPercentage)
          values.discountPercentage = Number(values.discountPercentage);
        if (values.offeredPrice)
          values.offeredPrice = Number(values.offeredPrice);
        if (values.type) values.type = Number(values.type);
        if (values.iveCredits) values.iveCredits = Number(values.iveCredits);
        if (values.adsCredits) values.adsCredits = Number(values.adsCredits);
        if (values.daysCovered) values.daysCovered = Number(values.daysCovered);
        if (values.sort) values.sort = Number(values.sort);
        if (values.realtedTypeSlug)
          values.realtedTypeSlug = Number(values.realtedTypeSlug);
        if (values.isMostPopular != null)
          values.isMostPopular = Boolean(values.isMostPopular);
        if (values.singleUse != null)
          values.singleUse = Boolean(values.singleUse);
        if (color.value) values.color = color.value;
        if (viewColor.value) values.viewColor = viewColor.value;
        if (priceColor.value) values.priceColor = priceColor.value;
        if (values.titleAr) values.titleAr = String(values.titleAr);
        if (values.titleEn) values.titleEn = String(values.titleEn);
        if (values.descriptionAr)
          values.descriptionAr = String(values.descriptionAr);
        if (values.descriptionEn)
          values.descriptionEn = String(values.descriptionEn);

        await store.dispatch(Actions.UPDATE_PACKAGE, {
          id: packageData.value?.id,
          data: values,
        });

        const [errorName] = Object.keys(store.getters.getErrors);
        const error = store.getters.getErrors[errorName];

        if (error) {
          Swal.fire({
            text: translate(error[0]),
            icon: 'error',
            buttonsStyling: false,
            confirmButtonText: translate('tryAgain'),
            customClass: {
              confirmButton: 'btn fw-bold btn-light-danger',
            },
          });
          submitButton.value?.removeAttribute('data-kt-indicator');
          if (submitButton.value) submitButton.value.disabled = false;
        } else {
          Swal.fire({
            text: translate('PACKAGE_UPDATE_SUCCESS'),
            icon: 'success',
            buttonsStyling: false,
            confirmButtonText: translate('ok'),
            customClass: {
              confirmButton: 'btn btn-light-primary',
            },
          }).then(() => {
            submitButton.value?.removeAttribute('data-kt-indicator');
            if (submitButton.value) submitButton.value.disabled = false;
            router.push({ name: 'packages-listing' });
          });
        }
      };

      return {
        priceColor,
        viewColor,
        color,
        packageData,
        submitButton,
        offeredPrice,
        onSubmitUpdate,
        translate,
        packageSchema,
        packageTypeOptions,
        goBack,
        can,
      };
    },
  });
